import { styled } from 'solid-styled-components';
import theme from '../../style/theme';
import { userProfileGridStyle } from '../user-profile-menu/user-profile-menu-desktop/user-profile-menu-desktop.styles';

export const StyledAccountEducationContent = styled.div``;

export const StyledLinkToAllCourses = styled.div`
    margin-top: 6rem;
    margin-bottom: 4rem;
    background-color: ${theme.palette.white};
    padding-top: 4rem;
    padding-bottom: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: ${theme.borderRadius.large};
`;

export const StyledSectionContainer = styled.div`
    container-type: inline-size;
    margin-top: 3.5rem;
`;

export const StyledAccountCoursesInProgressGrid = styled.div`
    ${userProfileGridStyle}
`;

export const StyledAccountCertificatesGrid = styled.div`
    ${userProfileGridStyle}
`;

